import wireListText from '!!raw-loader!@/assets/wireList.txt'
import targetNumberListText from '!!raw-loader!@/assets/targetNumberList.txt'
import wireLengthListText from '!!raw-loader!@/assets/wireLengthList.txt'
import ringSpecText from '!!raw-loader!@/assets/ringSpec.txt'
import hookSpecText from '!!raw-loader!@/assets/hookSpec.txt'
import hookTableText from '!!raw-loader!@/assets/hookTable.txt'
import ringTableText from '!!raw-loader!@/assets/ringTable.txt'
import diameterTableText from '!!raw-loader!@/assets/diameterTable.txt'
import wireKakouTankaTableText from '!!raw-loader!@/assets/wireKakouTankaTable.txt'

export default class Sling {
    // げんばのドンのリンク
    //static linkDon = "https://www.genbanodon.com/shop/enq201907040"
    static linkDon = "https://www.genbanodon.com/html/page27.html"

    static ringImages: { [code: string]: string } = {
        A01: "ring_tanzoUchinuki.png",
        A02: "ring_tanzoUchinuki.png",
        A03: "ring_tanzoUchinuki.png",
        A04: "ring_tanzoUchinuki.png",
        A05: "ring_tanzoUchinuki.png",
        A06: "ring_tanzoUchinuki.png",
        A07: "ring_tanzoUchinuki.png",
        P01: "ring_PEWAG_A8W.png",
        P02: "ring_PEWAG_A8W.png",
        P03: "ring_PEWAG_A8W.png",
        P04: "ring_PEWAG_A8W.png",
        P05: "ring_PEWAG_A8W.png",
        P06: "ring_PEWAG_A8W.png",
        P07: "ring_PEWAG_M8W.png",
        P08: "ring_PEWAG_M8W.png",
        P09: "ring_PEWAG_M8W.png",
        P10: "ring_PEWAG_M8W.png",
        P11: "ring_PEWAG_M8W.png",
        P12: "ring_PEWAG_M8W.png",
        K01: "ring_KITO_HMM.png",
        K02: "ring_KITO_HMM.png",
        K03: "ring_KITO_HMM.png",
        K04: "ring_KITO_HMM.png",
        K05: "ring_KITO_HMM.png",
        K06: "ring_KITO_HMH.png",
        K07: "ring_KITO_HMH.png",
        K08: "ring_KITO_HMH.png",
        K09: "ring_KITO_HMH.png",
        M01: "ring_MARTEC_MFA.png",
        M02: "ring_MARTEC_MFA.png",
        M03: "ring_MARTEC_MFA.png",
        M04: "ring_MARTEC_MFA.png",
        M05: "ring_MARTEC_MFA.png",
        M06: "ring_MARTEC_MFA.png",
    }

    static hookImages: { [code: string]: { [numberCode: string]: string } } = {
        L01: { 2: "hook_KONDOTEC_LS_2.png", 4: "hook_KONDOTEC_LS_4.png" },
        L02: { 2: "hook_KONDOTEC_LS_2.png", 4: "hook_KONDOTEC_LS_4.png" },
        L03: { 2: "hook_KONDOTEC_LS_2.png", 4: "hook_KONDOTEC_LS_4.png" },
        L04: { 2: "hook_KONDOTEC_LS_2.png", 4: "hook_KONDOTEC_LS_4.png" },
        L05: { 2: "hook_KONDOTEC_LS_2.png", 4: "hook_KONDOTEC_LS_4.png" },
        L06: { 2: "hook_KONDOTEC_LS_2.png", 4: "hook_KONDOTEC_LS_4.png" },
        A01: { 2: "hook_KONDOTEC_2.png", 4: "hook_KONDOTEC_4.png" },
        A02: { 2: "hook_KONDOTEC_2.png", 4: "hook_KONDOTEC_4.png" },
        A03: { 2: "hook_KONDOTEC_2.png", 4: "hook_KONDOTEC_4.png" },
        A04: { 2: "hook_KONDOTEC_2.png", 4: "hook_KONDOTEC_4.png" },
        A05: { 2: "hook_KONDOTEC_2.png", 4: "hook_KONDOTEC_4.png" },
        A06: { 2: "hook_KONDOTEC_2.png", 4: "hook_KONDOTEC_4.png" },
        A07: { 2: "hook_KONDOTEC_2.png", 4: "hook_KONDOTEC_4.png" },
        P01: { 2: "hook_PEWAG_LHW_2.png", 4: "hook_PEWAG_LHW_4.png" },
        P02: { 2: "hook_PEWAG_LHW_2.png", 4: "hook_PEWAG_LHW_4.png" },
        P03: { 2: "hook_PEWAG_LHW_2.png", 4: "hook_PEWAG_LHW_4.png" },
        P04: { 2: "hook_PEWAG_LHW_2.png", 4: "hook_PEWAG_LHW_4.png" },
        P05: { 2: "hook_PEWAG_LHW_2.png", 4: "hook_PEWAG_LHW_4.png" },
        P06: { 2: "hook_PEWAG_WLHW_2.png", 4: "hook_PEWAG_WLHW_4.png" },
        P07: { 2: "hook_PEWAG_WLHW_2.png", 4: "hook_PEWAG_WLHW_4.png" },
        P08: { 2: "hook_PEWAG_WLHW_2.png", 4: "hook_PEWAG_WLHW_4.png" },
        P09: { 2: "hook_PEWAG_WLHW_2.png", 4: "hook_PEWAG_WLHW_4.png" },
        P10: { 2: "hook_PEWAG_WLHW_2.png", 4: "hook_PEWAG_WLHW_4.png" },
        P11: { 2: "hook_PEWAG_FW_2.png", 4: "hook_PEWAG_FW_4.png" },
        P12: { 2: "hook_PEWAG_FW_2.png", 4: "hook_PEWAG_FW_4.png" },
        P13: { 2: "hook_PEWAG_FW_2.png", 4: "hook_PEWAG_FW_4.png" },
        P14: { 2: "hook_PEWAG_FW_2.png", 4: "hook_PEWAG_FW_4.png" },
        K01: { 2: "hook_KITO_HJJ_2.png", 4: "hook_KITO_HJJ_4.png" },
        K02: { 2: "hook_KITO_HJJ_2.png", 4: "hook_KITO_HJJ_4.png" },
        K03: { 2: "hook_KITO_HJJ_2.png", 4: "hook_KITO_HJJ_4.png" },
        K04: { 2: "hook_KITO_HJJ_2.png", 4: "hook_KITO_HJJ_4.png" },
        K05: { 2: "hook_KITO_HJJ_2.png", 4: "hook_KITO_HJJ_4.png" },
        K06: { 2: "hook_KITO_HJK_2.png", 4: "hook_KITO_HJK_4.png" },
        K07: { 2: "hook_KITO_HJK_2.png", 4: "hook_KITO_HJK_4.png" },
        K08: { 2: "hook_KITO_HJK_2.png", 4: "hook_KITO_HJK_4.png" },
        K09: { 2: "hook_KITO_HJK_2.png", 4: "hook_KITO_HJK_4.png" },
        K10: { 2: "hook_KITO_HTL_2.png", 4: "hook_KITO_HTL_4.png" },
        K11: { 2: "hook_KITO_HTL_2.png", 4: "hook_KITO_HTL_4.png" },
        K12: { 2: "hook_KITO_HTL_2.png", 4: "hook_KITO_HTL_4.png" },
        K13: { 2: "hook_KITO_HTL_2.png", 4: "hook_KITO_HTL_4.png" },
        K14: { 2: "hook_KITO_HTL_2.png", 4: "hook_KITO_HTL_4.png" },
        M01: { 2: "hook_MARTEC_BK_2.png", 4: "hook_MARTEC_BK_4.png" },
        M02: { 2: "hook_MARTEC_BK_2.png", 4: "hook_MARTEC_BK_4.png" },
        M03: { 2: "hook_MARTEC_BK_2.png", 4: "hook_MARTEC_BK_4.png" },
        M04: { 2: "hook_MARTEC_BK_2.png", 4: "hook_MARTEC_BK_4.png" },
        M05: { 2: "hook_MARTEC_BK_2.png", 4: "hook_MARTEC_BK_4.png" },
        M06: { 2: "hook_MARTEC_BKL_2.png", 4: "hook_MARTEC_BKL_4.png" },
        M07: { 2: "hook_MARTEC_BKL_2.png", 4: "hook_MARTEC_BKL_4.png" },
        M08: { 2: "hook_MARTEC_BKL_2.png", 4: "hook_MARTEC_BKL_4.png" },
        M09: { 2: "hook_MARTEC_BKL_2.png", 4: "hook_MARTEC_BKL_4.png" },
        M10: { 2: "hook_MARTEC_BKL_2.png", 4: "hook_MARTEC_BKL_4.png" },
        M11: { 2: "hook_MARTEC_OKE_2.png", 4: "hook_MARTEC_OKE_4.png" },
        M12: { 2: "hook_MARTEC_OKE_2.png", 4: "hook_MARTEC_OKE_4.png" },
        M13: { 2: "hook_MARTEC_OKE_2.png", 4: "hook_MARTEC_OKE_4.png" },
        M14: { 2: "hook_MARTEC_OKE_2.png", 4: "hook_MARTEC_OKE_4.png" },
    }

    static wireImages: { [code: string]: { [numberCode: string]: string } } = {
        1: { 2: "rope_Lock_2.png", 4: "rope_Lock_4.png" },
        2: { 2: "rope_Braid_2.png", 4: "rope_Braid_4.png" },
        3: { 2: "rope_ThimbleLock_2.png", 4: "rope_ThimbleLock_4.png" },
        4: { 2: "rope_ThimbleBraid_2.png", 4: "rope_ThimbleBraid_4.png" },
        5: { 2: "rope_Lock_1eye_2.png", 4: "rope_Lock_1eye_4.png" },
        6: { 2: "rope_Braid_1eye_2.png", 4: "rope_Braid_1eye_4.png" },
        7: { 2: "rope_1ThimbleLock_1eye_2.png", 4: "rope_1ThimbleLock_1eye_4.png" },
        8: { 2: "rope_1ThimbleBraid_1eye_2.png", 4: "rope_1ThimbleBraid_1eye_4.png" },
    }

    // 重量
    targetWeightCode: string | null = null

    // 吊り本数
    targetNumberCode: string | null = null

    // ワイヤ加工方法
    wireCode: string | null = null

    // 長さ
    wireLengthCode: string | null = null

    // リングの種類
    ringCode: string | null = null

    // フックの種類
    hookCode: string | null = null

    //  吊り荷の質量 
    static _targetWeights: { [code: string]: number } = {
        "1": 0.5,
        "2": 1,
        "3": 2,
        "4": 2.5,
        "5": 3,
        "6": 5,
        "7": 8,
        "8": 10,
    }

    get targetWeights() {
        return Sling._targetWeights
    }

    // 径に対するワイヤーの単価
    static wireTankas: { [diameter: number]: number } = {
        8: 130,
        9: 143,
        12: 202,
        14: 246,
        16: 305,
        20: 441,
        24: 673,
        28: 899,
        10: 158,
        22: 580,
    }

    /**
     * 吊り荷の質量 
     */
    get targetWeight() {
        if (!this.targetWeightCode) return null

        return this.targetWeights[this.targetWeightCode]
    }

    /**
     * 吊り本数
     */
    get targetNumber() {
        if (!this.targetNumberCode) return null

        return this.targetNumbers[this.targetNumberCode]
    }

    /**
     * ワイヤ径（質量と吊り本数から）
     */
    get diameter(): number | null {
        if (this.targetWeightCode === null) return null
        if (this.targetNumberCode === null) return null

        return this.diameterTable[this.targetNumberCode][this.targetWeightCode]
    }

    /**
     * ワイヤ加工方法
     */
    get wire() {
        if (this.wireCode === null) return null

        return this.wires[this.wireCode]
    }

    /**
     * ワイヤ長さL 
     */
    get wireLength() {
        if (!this.wireLengthCode) return null

        return this.wireLengths[this.wireLengthCode]
    }

    /**
     * リング長さL 
     */
    get ringLength() {
        if (!this.ringSpec) return null
        return this.ringSpec["length"]
    }

    /**
     * リングW
     */
    get ringWidth() {
        if (!this.ringSpec) return null
        return this.ringSpec["width"]
    }

    /**
     * リングΦ
     */
    get ringPhi() {
        if (!this.ringSpec) return null
        return this.ringSpec["phi"]
    }

    /**
     * フックL
     */
    get hookLength() {
        if (!this.hookSpec) return null
        return this.hookSpec["length"]
    }

    /**
     * ワイヤ画像名
     */
    get wireImageName() {
        if (!this.wireCode) return null
        if (!this.targetNumberCode) return null
        if (!(this.wireCode in Sling.wireImages)) return null
        if (!(this.targetNumberCode in Sling.wireImages[this.wireCode])) return null

        return Sling.wireImages[this.wireCode][this.targetNumberCode]
    }

    /**
     * リング画像名
     */
    get ringImageName() {
        if (!this.ringSpec) return null
        if (!(this.ringSpec.code in Sling.ringImages)) return null

        return Sling.ringImages[this.ringSpec.code]
    }

    /**
     * フック画像名
     */
    get hookImageName() {
        if (!this.hookSpec) return null
        if (!this.targetNumberCode) return null
        if (!(this.hookSpec.code in Sling.hookImages)) return null
        if (!(this.targetNumberCode in Sling.hookImages[this.hookSpec.code])) return null

        return Sling.hookImages[this.hookSpec.code][this.targetNumberCode]
    }

    /**
     * ワイヤ画像
     */
    get wireImage() {
        if (!this.wireImageName) return null
        return require("@/assets/images/" + this.wireImageName)
    }

    /**
     * リング画像
     */
    get ringImage() {
        if (!this.ringImageName) return null
        return require("@/assets/images/" + this.ringImageName)
    }

    /**
     * フック画像
     */
    get hookImage() {
        if (!this.hookImageName) return null
        return require("@/assets/images/" + this.hookImageName)
    }

    /**
     * 合計価格
     */
    get kakakuOrg() {
        if (!this.ringKakaku || this.hookKakaku === null || !this.wireKakakuSum) return null

        //return (this.ringKakaku + this.hookKakaku + this.wireKakakuSum) * 2.5
        return (this.ringKakaku + this.hookKakaku + this.wireKakakuSum) * 3.0
    }
    /**
     * 合計価格（丸めたもの。最終）
     */
    get kakaku() {
        if (!this.kakakuOrg) return null

        const kakaku = this.kakakuOrg

        if (kakaku < 10000) {
            return Sling.numberFormat(Math.floor(kakaku / 10) * 10)
        }
        else if (kakaku < 100000) {
            return Sling.numberFormat(Math.floor(kakaku / 100) * 100)
        }
        return Sling.numberFormat(Math.floor(kakaku / 1000) * 1000)
    }

    static numberFormat(kakaku: number): string {
        if (kakaku >= 1000000) {
            const k1 = String(Math.floor(kakaku / 1000000))
            const k2 = ("000" + (Math.floor(kakaku / 1000) % 1000)).substr(-3)
            const k3 = ("000" + (kakaku % 1000)).substr(-3)

            return [k1, k2, k3].join(",")
        }
        else if (kakaku >= 1000) {
            const k1 = String(Math.floor(kakaku / 1000))
            const k2 = ("000" + (kakaku % 1000)).substr(-3)

            return [k1, k2].join(",")
        }
        return String(kakaku)
    }

    /**
     * リングのスペック情報
     */
    get ringSpec() {
        if (!this.ringCode || !(this.ringCode in this.ringSpecs)) {
            return null
        }

        if (this.ringCodes.indexOf(this.ringCode) < 0) {
            return null
        }

        return this.ringSpecs[this.ringCode]
    }

    get ring() {
        if (!this.ringSpec) return null

        return this.ringSpec.name
    }

    get hook() {
        if (!this.hookSpec) return null

        return this.hookSpec.name
    }

    /**
     * フックのスペック情報
     */
    get hookSpec() {
        if (!this.hookCode || !(this.hookCode in this.hookSpecs)) {
            return null
        }

        if (this.hookCodes.indexOf(this.hookCode) < 0) {
            return null
        }

        return this.hookSpecs[this.hookCode]
    }

    /**
     * ワイヤーの長さ（価格計算用）
     */
    get wireKakakuLength() {
        if (!this.wireLength) return null

        return Math.ceil(this.wireLength)
    }

    /**
     * ワイヤーの本数（価格計算用）
     */
    get wireCount() {
        if (!this.targetNumberCode) return null

        if (this.targetNumberCode == "2") {
            return 2
        }
        if (this.targetNumberCode == "4") {
            return 4
        }

        return null
    }

    /**
     * シンブルの数（価格計算用）
     * ワイヤー×2
     */
    get wireThimbleCount() {
        if (!this.wireCount) return null
        return this.wireCount * 2
    }

    /**
     * リングの価格
     */
    get ringKakaku(): number | null {
        if (this.ringSpec) {
            return Number(this.ringSpec.kakaku)
        }
        return null
    }

    /**
     * フックの価格
     */
    get hookKakaku(): number | null {
        if (this.hookSpec) {
            if (this.wireCount == 2) {
                return Number(this.hookSpec.kakaku2)
            }
            else {
                return Number(this.hookSpec.kakaku4)
            }
        }
        return null
    }

    /**
     * ワイヤの合計価格
     */
    get wireKakakuSum(): number | null {
        if (this.wireKakaku && this.wireKakouKakaku) {
            return this.wireKakaku + this.wireKakouKakaku
        }
        return null
    }

    /**
     * ワイヤの材料単価
     */
    get wireTanka(): number | null {
        if (this.diameter && this.diameter in Sling.wireTankas) {
            return Sling.wireTankas[this.diameter]
        }
        return null
    }

    /**
     * ワイヤの材料価格
     */
    get wireKakaku(): number | null {
        if (!this.wireCount) return null
        if (!this.wireKakakuLength) return null
        if (!this.wireTanka) return null

        return this.wireCount * this.wireKakakuLength * this.wireTanka
    }

    /**
     * ワイヤの加工単価
     */
    get wireKakouTanka(): number | null {
        if (!this.diameter) return null
        if (!this.wireCode) return null

        if (this.wireCode in this.wireKakouTankaTable) {
            if (this.diameter in this.wireKakouTankaTable[this.wireCode]) {
                return this.wireKakouTankaTable[this.wireCode][this.diameter]
            }
        }

        return null
    }

    /**
     * ワイヤの加工価格
     */
    get wireKakouKakaku(): number | null {
        if (!this.wireThimbleCount) return null
        if (!this.wireKakouTanka) return null

        return this.wireThimbleCount * this.wireKakouTanka
    }

    /**
     * コード
     */
    get code() {
        if (!this.ringSpec) return null
        if (!this.targetNumberCode) return null
        if (!this.wireCode) return null
        if (!this.wireLengthCode) return null
        if (!this.hookSpec) return null
        if (!this.diameter) return null

        return [
            this.ringSpec.code,
            this.targetNumberCode,
            this.wireCode,
            ("00" + (this.diameter)).slice(-2),
            this.wireLengthCode,
            this.hookSpec.code,
        ].join("")
    }

    /**
     * リングのコードリスト
     */
    get ringCodes(): string[] {
        if (this.targetNumberCode === null || this.targetWeightCode === null) {
            return []
        }

        if (!(this.targetNumberCode in this.ringTable)) {
            return []
        }

        if (!(this.targetWeightCode in this.ringTable[this.targetNumberCode])) {
            return []
        }

        return this.ringTable[this.targetNumberCode][this.targetWeightCode]
    }

    /**
     * フックのコードリスト
     */
    get hookCodes(): string[] {
        if (this.targetNumberCode === null || this.targetWeightCode === null || this.wireCode === null) {
            return []
        }

        if (!(this.targetNumberCode in this.hookTable)) {
            return []
        }

        if (!(this.targetWeightCode in this.hookTable[this.targetNumberCode])) {
            return []
        }

        // フックなしの加工方法を選択した場合
        if (this.wireCode >= "5") {
            return ["N00"]
        }

        return this.hookTable[this.targetNumberCode][this.targetWeightCode]
    }

    /**
     * ワイヤ加工方法のリスト
     */
    get wires() {
        const rows = wireListText.split("\n").map(row => {
            return row.split("\t").map(value => { return value.trim() })
        })

        // ヘッダ
        rows.shift();

        const table: { [code: string]: string } = {}

        rows.forEach(row => {
            if (row.length >= 2) {
                const code = row.shift()
                const value = row.shift()

                if (code === undefined) return
                if (value === undefined) return

                table[code] = value
            }
        })

        return table
    }

    /**
     * 
     */
    get wireLengths() {
        /*
        const rows = wireLengthListText.split("\n").map(row => {
            return row.split("\t").map(value => { return value.trim() })
        })

        // ヘッダ
        rows.shift();

        const table: { [code: string]: number } = {}

        rows.forEach(row => {
            if (row.length >= 2) {
                const code = row.shift()
                const value = row.shift()

                if (code === undefined) return
                if (value === undefined) return

                table[code] = Number(value)
            }
        })

        return table
        */
        const table: { [code: string]: number } = {}

        if (this.wireCode && this.diameter) {
            //2 編み込み（段落し）
            //4 シンブル入り　編み込み(段落し)
            //6 編み込み（段落し）　片アイ標準(フック無し)
            //8 片シンブル入り編み込み(段落し)　片アイ標準
            if (this.wireCode == "2" || this.wireCode == "4" || this.wireCode == "6" || this.wireCode == "8") {
                if (this.diameter <= 16) {
                    for (let n = 10; n <= 60; n++) {
                        table[n] = n / 10.0
                    }
                }
                else if (this.diameter == 20) {
                    for (let n = 16; n <= 60; n++) {
                        table[n] = n / 10.0
                    }
                }
                else if (this.diameter == 22) {
                    for (let n = 18; n <= 60; n++) {
                        table[n] = n / 10.0
                    }
                }
                else if (this.diameter == 24) {
                    for (let n = 20; n <= 60; n++) {
                        table[n] = n / 10.0
                    }
                }
                else if (this.diameter == 28) {
                    for (let n = 23; n <= 60; n++) {
                        table[n] = n / 10.0
                    }
                }
            }
            else {
                if (this.diameter <= 24) {
                    for (let n = 10; n <= 60; n++) {
                        table[n] = n / 10.0
                    }
                }
                else if (this.diameter == 28) {
                    for (let n = 12; n <= 60; n++) {
                        table[n] = n / 10.0
                    }
                }

            }
        }

        return table
    }

    /**
     * 
     */
    get targetNumbers() {
        const rows = targetNumberListText.split("\n").map(row => {
            return row.split("\t").map(value => { return value.trim() })
        })

        // ヘッダ
        rows.shift();

        const table: { [code: string]: string } = {}

        rows.forEach(row => {
            if (row.length >= 2) {
                const code = row.shift()
                const value = row.shift()

                if (code === undefined) return
                if (value === undefined) return

                table[code] = value
            }
        })

        return table
    }

    /**
     * 
     */
    get diameterTable() {
        const rows = diameterTableText.split("\n").map(row => {
            return row.split("\t").map(value => { return value.trim() })
        })

        // ヘッダ
        rows.shift();

        const table: { [number: string]: { [weight: string]: number } } = {}

        rows.forEach(row => {
            if (row.length >= 3) {
                const number = row[0]
                const weight = row[1]
                const value = row[2]

                if (!(number in table)) {
                    table[number] = {}
                }

                table[number][weight] = Number(value)
            }
        })

        return table
    }

    /**
     * リング対応表
     */
    get ringTable() {
        const rows = ringTableText.split("\n").map(row => {
            return row.split("\t").map(value => { return value.trim() })
        })

        // ヘッダ
        rows.shift();

        const table: { [number: string]: { [weight: string]: string[] } } = {}

        rows.forEach(row => {
            if (row.length >= 3) {
                const rnumber = row.shift()
                const rweight = row.shift()

                if (rnumber === undefined) return
                if (rweight === undefined) return

                const number = rnumber
                const weight = rweight

                if (!(number in table)) {
                    table[number] = {}
                }

                table[number][weight] = row.filter(value => {
                    return value != ""
                })
            }
        })

        return table
    }

    /**
     * フック対応表
     */
    get hookTable() {
        const rows = hookTableText.split("\n").map(row => {
            return row.split("\t").map(value => { return value.trim() })
        })

        // ヘッダ
        rows.shift();

        const table: { [number: string]: { [weight: string]: string[] } } = {}

        rows.forEach(row => {
            if (row.length >= 3) {
                const rnumber = row.shift()
                const rweight = row.shift()

                if (rnumber === undefined) return
                if (rweight === undefined) return

                const number = rnumber
                const weight = rweight

                if (!(number in table)) {
                    table[number] = {}
                }

                table[number][weight] = row.filter(value => {
                    return value != ""
                })
            }
        })

        return table
    }

    /**
     * リングスペック表
     */
    get ringSpecs() {
        const rows = ringSpecText.split("\n").map(row => {
            return row.split("\t").map(value => { return value.trim() })
        })

        // ヘッダ
        rows.shift();

        const table: { [code: string]: { [key: string]: string } } = {}

        rows.forEach(row => {
            const code = row[0]

            if (row.length >= 6) {
                table[code] = {
                    "code": row[0],
                    "name": row[1],
                    "kakaku": row[2],
                    "length": row[3],
                    "width": row[4],
                    "phi": row[5],
                }
            }
        })

        return table
    }

    /**
     * フックスペック表
     */
    get hookSpecs() {
        const rows = hookSpecText.split("\n").map(row => {
            return row.split("\t").map(value => { return value.trim() })
        })

        // ヘッダ
        rows.shift();

        const table: { [code: string]: { [key: string]: string } } = {}

        rows.forEach(row => {
            const code = row[0]

            if (row.length >= 6) {
                table[code] = {
                    "code": row[0],
                    "name": row[1],
                    "kakaku2": row[2],
                    "kakaku4": row[3],
                    "kakaku": row[4],
                    "length": row[5],
                }
            }
        })

        return table
    }

    /**
     * ワイヤ加工単価表
     */
    get wireKakouTankaTable() {
        const rows = wireKakouTankaTableText.split("\n").map(row => {
            return row.split("\t").map(value => { return value.trim() })
        })

        // ヘッダ
        const header = rows.shift();

        if (!header) return {}

        const table: { [wireCode: string]: { [diameter: number]: number } } = {}

        rows.forEach(row => {
            if (row.length >= 9) {
                const diameter = Number(row[0])

                for (let x = 1; x < header.length; x++) {
                    const wireCode: string = header[x]
                    const kakaku = Number(row[x])

                    if (!(wireCode in table)) {
                        table[wireCode] = {}
                    }

                    table[wireCode][diameter] = kakaku
                }
            }
        })

        return table
    }

}
